export default __webpack_public_path__ + "locales/sr-Cyrl-RS/RoomLogoCover.json?hash=13bd4b7743a3b3cac8801a81b455a655";